import React from 'react';
export function CourseCosts() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2310">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2311">
        <div className="mb-12" data-id="element-2312">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2313">
            Course Costs
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2314">
            <div className="overflow-x-auto" data-id="element-2315">
              <table className="w-full text-left border-collapse" data-id="element-2316">
                <thead data-id="element-2317">
                  <tr style={{
                  backgroundColor: '#1e3d2f'
                }} data-id="element-2318">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2319">
                      Membership
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2320">
                      Tuition
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-2321">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-2322">
                    <td className="p-4 font-medium text-gray-800" data-id="element-2323">
                      FLSC Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-2324">$140.00</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-2325">
                    <td className="p-4 font-medium text-gray-800" data-id="element-2326">
                      Non-Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-2327">$220.00</td>
                  </tr>
                  <tr data-id="element-2328">
                    <td colSpan={2} className="p-4 text-sm text-gray-500 bg-gray-50 italic" data-id="element-2329">
                      Tuition is non-refundable except in the case of cancelled
                      classes.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}